import type { ValueOf } from '@vy/utils';
import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const SYNC_DIRECTIONS = Object.freeze({
  SYNC_FROM_VAYU: 'sync-from-vayu',
  SYNC_TO_VAYU: 'sync-to-vayu',
  AUTO_SYNC_DISABLED: 'auto-sync-disabled',
});

export type SyncDirection = ValueOf<typeof SYNC_DIRECTIONS>;

export const StripeConfigurationFormSchema = oz.object({
  apiToken: oz.string(),
  syncCustomer: oz.nativeEnum(SYNC_DIRECTIONS).optional(),
  syncApprovedInvoices: oz.boolean().optional(),
  syncPaymentRefIdToErp: oz.boolean().optional(),
});

export type StripeConfigurationFormValues = oz.infer<typeof StripeConfigurationFormSchema>;
export type StripeConfigurationControl = Control<StripeConfigurationFormValues>;
